import React, { useState } from 'react';
import './LandingPage.css';
import { useAuth } from './auth';
import { GoogleLogin } from '@react-oauth/google';
import { logEvent } from './analytics';
import { useNavigate } from 'react-router-dom';
import { PhoneInput, defaultCountries,  parseCountry } from 'react-international-phone';
import { LoginPage } from './LoginPage';

import { getBackendURL } from './utils';

const VIDEO_DEMO_URL = 'https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/ptc_screenflow.mov';

export function SweatTextLandingPage() {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const { user, login, specialSignup } = useAuth();
  const [err, setErr] = useState('');
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [showGoogleLogin, setShowGoogleLogin] = useState(false);
  const [showTestGoogleLogin, setShowTestGoogleLogin] = useState(false);
  const [showFAQ, setShowFAQ] = useState(false); // (kept; do not alter anything before first testimonial)



  const [phone, setPhone] = useState('');
  const [isPhoneValid, setIsPhoneValid] = useState(true);

  React.useEffect(() => {
    // Simple international phone validation: starts with + and at least 10 digits
    const digits = phone.replace(/\D/g, '');
    setIsPhoneValid(phone.startsWith('+') && digits.length >= 10);
  }, [phone]);

const countries = defaultCountries.filter((country) => {
  const { iso2 } = parseCountry(country);
  return ['us'].includes(iso2);
});

    const [googleToken, setGoogleToken] = useState(null);
  const { login: authLogin, fetchUserInfo, pureFetchUserInfo } = useAuth();






  const handleTestSend = async (credentialResponse) => {




    if (!credentialResponse.credential) {
      setErr('No Google credential received.');
      return false;
    }
    setErr('');

    const res = await specialSignup({ 
        google_credential: credentialResponse.credential,
      phone: phone,

     });

     if (!res.success) {
        setErr('Google login or test message failed.');
        return false;
     }
  };


  return (
    <div className="landing-page-container fogged-card">
      <h1 className="landing-page-title">Welcome to SweatText!</h1>


      {/* Responsive row layout */}
      <div className="landing-page-row">
        <div className="landing-page-col left">
          <div className="landing-page-description">
            <span style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#d99a00' }}>
              Automated SMS session reminders for fitness professionals to their clients.
            </span>
          </div>
          <div className="landing-page-description">
            <ul>
              <li style={{ listStyleType: 'none', marginBottom: 8 }}><span style={{ color: 'green', fontWeight: 'bold', marginRight: 6 }}>✓</span>Fewer no-shows and late clients</li>
              <li style={{ listStyleType: 'none', marginBottom: 8 }}><span style={{ color: 'green', fontWeight: 'bold', marginRight: 6 }}>✓</span>Less time on your phone</li>
              <li style={{ listStyleType: 'none', marginBottom: 8 }}><span style={{ color: 'green', fontWeight: 'bold', marginRight: 6 }}>✓</span>Privacy-focused, no spam</li>
            </ul>
          </div>
          {/* Start of buttons */}
          <div style={{ width: '100%', maxWidth: 300,
           }}>


            <div style={{ background: 'gold', color: 'black',
            fontWeight: 'bold',
            fontSize: '1rem',
              borderRadius: 6, padding: '12px 14px', marginBottom: '1rem',
            }} >
                
              Start within seconds with a free example text reminder to your phone number!
              <span style={{ fontSize: '0.8rem', color: '#555', marginLeft: 6 }}>
                - No Card Needed*
              </span>





                <span style={{ marginTop: '1rem', display: 'flex', width: '100%' }}>
                  <PhoneInput
                    defaultCountry="us"
                    countries={countries}
                    value={phone}
                    onChange={value => {
                      setPhone(value);
                    }}
                    style={{
                      borderRadius: '4px',
                      width: '100%',
                      boxSizing: 'border-box',
                    }}
                  />
                  <button
                    style={{ width: '100%', background: isPhoneValid ? 'orange' : '#ccc', color: 'black', border: 'none', borderRadius: 6, fontWeight: 'bold', fontSize: '1rem', padding: '0.75rem 1rem', marginBottom: 12, cursor: isPhoneValid ? 'pointer' : 'not-allowed' }}
                    disabled={!isPhoneValid}
                    onClick={() => {
                      logEvent('try_quick_test', { method: 'button' });
                      setShowTestGoogleLogin(true);
                              }}
                  >Send
                  </button>
                </span>
                

                {showTestGoogleLogin && 

                <div style={{ marginTop: '1rem' }}>
                  <div style={{ marginBottom: 8, fontSize: '0.95rem'}}>
                    To confirm you're not a bot, please sign in with Google. 
                    By signing in, you consent to receive transactional messages including a daily summary from SweatText 
                    and agree to our 
                    <a href="/terms" style={{ textDecoration: 'underline' }}>
                      Terms of Use
                    </a> 
                    and 
                    <a href="/privacy" style={{  textDecoration: 'underline' }}>
                      Privacy Policy
                    </a>.
                  </div>
                  <div style={{ marginBottom: 16, fontSize: '0.95rem' }}>
                    {/* <LoginPage onSuccess={handleTestSend} /> */}

                          <>
                            <div style={{textAlign: 'center', marginTop: 16, marginLeft: 'auto',
                              marginRight: 'auto', width: 'fit-content'}}>
                              <GoogleLogin
                                center
                                className="ptc-button"
                                onSuccess={handleTestSend}
                                onError={() => {
                                  setErr('Google login failed.');
                                }}
                                useOneTap
                              />
                            </div>
                            {err && <div style={{color: 'red', marginTop: 16, textAlign: 'center'}}>{err}</div>}
                          </>
                  </div>
                </div>
            }



            </div>


            {!showGoogleLogin ? (
              <button
                className="ptc-secondary-button"
                style={{ width: '100%',  border: 'none', borderRadius: 6, fontWeight: 'bold', fontSize: '1rem', padding: '0.75rem 1rem', marginBottom: 12 }}
                onClick={() => setShowGoogleLogin(true)}
              >
                Existing Trainer Users
              </button>
            ) : (
              <>
                <GoogleLogin
                  center
                  className="ptc-button"
                  style={{ width: '100%' }}
                  onSuccess={async credentialResponse => {
                    logEvent('google_login_attempt', { method: 'google' });
                    if (credentialResponse.credential) {
                      setErr('');
                      const res = await login({ google_credential: credentialResponse.credential });
                      if (!res.success) {
                        setErr('Google login failed.');
                      } else {
                        // navigate('/');
                      }

                      setGoogleToken(credentialResponse.credential);
                      
                    } else {
                      setErr('No Google credential received.');
                    }
                  }}
                  onError={() => {
                    setErr('Google login failed.');
                  }}
                  useOneTap
                />

                <span style={{ fontSize: '0.8rem', color: '#555', display: 'block', marginTop: 6, textAlign: 'center' }}>
                  By logging in, you agree to our <a href="/terms" style={{ color: '#555', textDecoration: 'underline' }}>Terms of Use</a>.
                </span>
              </>
            )}


            {/* Button for Clients to Ask Their  */}
          </div>
          {/* End of buttons */}
        </div>
        <div className="landing-page-col right">
          <img
            src="https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/ptc_banner.png"
            className="landing-page-banner"
            style={{ borderRadius: 8 }}
            alt="SweatText product screenshot"
          />
        </div>
      </div>


      




      {/* Rating + short testimonial (unchanged) */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 6, marginTop: '3rem', marginBottom: '3rem' }}>
        {[...Array(5)].map((_, i) => (
          <span key={i} style={{ color: '#ffd700', fontSize: '1.5rem' }}>★</span>
        ))}
        <span style={{ fontSize: '1rem', color: '#ddd', fontStyle: 'italic', marginLeft: 12 }}>
          “It is pretty straight forward!” — Anonymous User
        </span>
      </div>

      {/* Existing price blurb (unchanged before testimonials) */}
      {/* <div style={{ background: '#253440', borderRadius: 8, padding: '12px 14px', fontSize: '0.95rem', color: '#eee', boxShadow: '0 1px 6px rgba(0,0,0,0.15)' }}>
        <span className="landing-page-description" style={{ fontSize: '1.08rem', fontWeight: 'bold', color: '#222', borderRadius: 5, textAlign: 'left' }}>
          <span style={{ color: '#0077b6', fontWeight: 'bold', fontSize: '1.1rem', display: 'block', marginBottom: '3rem', marginTop: '3rem' }}>
            <span style={{ color: '#d99a00', fontWeight: 'bold', fontSize: '2rem' }}>Free</span> until Oct 1 2025, just <span style={{ color: '#d99a00', fontWeight: 'bold', fontSize: '2rem' }}>$5</span>/month after!*
          </span>
        </span>
      </div> */}



      {/* ================= NEW CONTENT STARTS HERE ================= */}

      {/* How It Works */}
      <h2 style={{ margin: '0 0 10px 0', fontSize: '1.25rem', color: '#fff' }}>How It Works</h2>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
          gap: 8,
          marginBottom: '3rem',
        }}
      >
        {[
          { t: 'Invite Client', 
            d: 'Enter their name and email.', 
            i: '👤' }, 
          { t: 'Schedule Sessions', 
              d: 'Set times/dates for training.', 
              i: '📅' }, 
          { t: 'We Send Texts', d: "Automatic reminders go out.", i: '📲' }, 
          { t: 'Client Shows Up', d: 'You coach. We remind.', i: '💪' }
        ].map((s, idx) => (
          <div key={idx} style={{ background: 'transparent', borderRadius: 8, 
            padding: '10px 12px',
          color: '#eee', boxShadow: '0 1px 6px rgba(0,0,0,0.15)' }}>
            <div style={{ fontSize: '1.25rem', marginBottom: 6 }}>{s.i}</div>
            <div style={{ fontWeight: 'bold' }}>{s.t}</div>
            <div style={{ opacity: 0.9 }}>{s.d}</div>
          </div>
        ))}
      </div>

      {/* Pricing + FAQ two-column row */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 12,
          alignItems: 'stretch',
          marginBottom: 20,
        }}
      >
        {/* Pricing Card */}
        <div>
          
          <div style={{ background: '#253440', 
                        borderRadius: 10, 
                        padding: 18, 
                        color: '#eee', 
                        boxShadow: '0 2px 10px rgba(0,0,0,0.15)' }}>
            <div style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: 8 }}>Free until Oct 1, 2025</div>
            <div style={{ fontSize: '0.95rem', marginBottom: 12 }}>→ Just <span style={{ color: '#d99a00', fontWeight: 'bold' }}>$5/month</span> after*</div>
            <ul style={{ paddingLeft: 18, margin: 0, lineHeight: 1.6 }}>
              <li>No card required</li>
              <li>Cancel anytime</li>
            </ul>
          </div>
        </div>

        {/* FAQ Column: collapsible answers, see more button for full list */}
        {(() => {
          const allFaqs = [
            { q: 'Who are you?', a: "I'm Alex, a solo software developer from Texas who loves the gym. For the past several months I've dedicated myself to building this project. I'm so grateful for the support from users so far. This is operated though Held Solutions LLC. See Contact for more." },
            { q: 'Can clients reply to reminders?', a: 'No, reminders only for now. This is considered a future potential feature.' },
            { q: 'Do I have to manually send texts?', a: 'No. Reminders are scheduled and sent automatically one hour before the start of each session.' },
            { q: 'Can I customize the message?', a: 'Basic customization is supported (client name, time, location, and a short note).' },
            { q: 'Will this spam my clients?', a: 'No. Reminders are limited, respectful, and opt‑in only. Clients can stop at any time.' },
            { q: 'What about privacy & compliance?', a: 'We follow SMS best practices and only use essential data to deliver reminders securely. See our Terms of Use for details.' },
            { q: 'Does it work if I don’t use a calendar?', a: 'Yes. For now, you must add sessions directly. Calendar integrations are planned.' },
            { q: 'Can I pause reminders?', a: 'Absolutely. You control when reminders go out.' },
            { q: 'What if my client and I don\'t meet at the same time each week?', a: 'You’ll need to edit the timeslot - for now - but more advanced scheduling is planned soon.' },
            { q: 'Is there a long‑term contract?', a: 'No. Early adopters are month‑to‑month at $5, and you can cancel anytime.' },
            { q: 'Do I need a credit card to try it?', a: 'No card is required to start your trial.' },
          ];
          const [openFaq, setOpenFaq] = useState(-1);
          const [showAllFaqs, setShowAllFaqs] = useState(false);
          const initialFaqs = [allFaqs[4], allFaqs[7]];
          const extraFaqs = allFaqs.filter((_, i) => i !== 4 && i !== 7);
          return (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 8 }}>
              {initialFaqs.map((f, i) => (
                <div key={i} style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, padding: 14, cursor: 'pointer' }}
                  onClick={() => setOpenFaq(openFaq === i ? -1 : i)}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontWeight: 'bold', color: '#fff' }}>{f.q}</div>
                    <span aria-hidden>{openFaq === i ? '˄' : '›'}</span>
                  </div>
                  {openFaq === i && (
                    <div style={{ marginTop: 6, color: '#e6e6e6' }}>{f.a}</div>
                  )}
                </div>
              ))}
              
              {!showAllFaqs && (
                <div style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, padding: 14, cursor: 'pointer' }}
                  onClick={() => setShowAllFaqs(true)}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontWeight: 'bold', color: '#fff' }}>See More FAQ...</div>
                                        <span aria-hidden>›</span>

                  </div>
                </div>
              )}
              {showAllFaqs && (
                <div style={{ background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, padding: 14, cursor: 'pointer' }}
                  onClick={() => setShowAllFaqs(false)}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontWeight: 'bold', color: '#fff' }}>See Less FAQ...</div>
                      <span aria-hidden>˄</span>

                  </div>
                </div>
              )}
              {showAllFaqs && extraFaqs.map((f, i) => (
                <div key={i+initialFaqs.length} style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, padding: 14, cursor: 'pointer' }}
                  onClick={() => setOpenFaq(openFaq === i+initialFaqs.length ? -1 : i+initialFaqs.length)}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontWeight: 'bold', color: '#fff' }}>{f.q}</div>
                    <span aria-hidden>{openFaq === i+initialFaqs.length ? '˄' : '›'}</span>
                  </div>
                  {openFaq === i+initialFaqs.length && (
                    <div style={{ marginTop: 6, color: '#e6e6e6' }}>{f.a}</div>
                  )}
                </div>
              ))}
            </div>
          );
        })()}
      </div>










      {/* Testimonials grid (first testimonial lives here; do not change prior content) */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12, marginTop: '3rem', marginBottom: '3rem' }}>
        <div style={{ background: '#253440', borderRadius: 8, padding: '12px 14px', fontSize: '0.95rem', color: '#eee', boxShadow: '0 1px 6px rgba(0,0,0,0.15)' }}>
          <div style={{ opacity: 0.95, fontStyle: 'italic' }}>“It was easy to sign up.”</div>
          <div style={{ marginTop: 6, fontWeight: 'bold', opacity: 0.9 }}>— Anonymous User</div>
        </div>
        {[{ q: '“Automated reminders cut my no‑shows dramatically.”', a: '— You, probably, if you sign up' }, { q: '“I love not having to text clients all the time.”', a: '— Also Potentially You' }].map((t, i) => (
          <div key={i} style={{ background: 'rgba(255,255,255,0.10)', borderRadius: 8, padding: '12px 14px', fontSize: '0.95rem', color: '#eee', boxShadow: '0 1px 6px rgba(0,0,0,0.15)' }}>
            <div style={{ opacity: 0.95, fontStyle: 'italic' }}>{t.q}</div>
            <div style={{ marginTop: 6, fontWeight: 'bold', opacity: 0.9 }}>{t.a}</div>
          </div>
        ))}
      </div>



      {/* Video Demo Modal (unchanged) */}
      {showVideoModal && (
        <div className="video-demo-modal" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', color: 'white', display: 'flex', alignItems: 'start', justifyContent: 'center', zIndex: 9999, paddingRight: '50px', margin: 0 }}>
          <div style={{ background: 'rgb(30,30,30)', zIndex: 10000, color: 'white', borderRadius: 8, padding: 24, maxWidth: '100vw', maxHeight: '100vh', margin: '10vh 0 0 0', position: 'relative', boxShadow: '0 2px 16px rgba(0,0,0,0.2)' }}>
            <button style={{ position: 'absolute', top: 8, right: 8, background: '#222', border: 'none', borderRadius: 4, padding: '4px 8px', cursor: 'pointer', fontWeight: 'bold' }} onClick={() => setShowVideoModal(false)}>Close</button>
            <video src={VIDEO_DEMO_URL} playsInline autoPlay controls style={{ width: '100%', maxHeight: '50vh', borderRadius: 8 }}>
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}

      {/* Removed the old FAQ toggle + long list; consolidated into three cards above */}

      {/* Terms note */}
      <span style={{ fontSize: '0.8rem', color: '#555', display: 'block', marginTop: 6 }}>
        * See <a href="/terms" style={{ color: '#555', textDecoration: 'underline' }}>Terms of Use</a> for details.
      </span>
    </div>
  );
}
